import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "@/lib/toast";
import api from "@/lib/api";
import { PageHeader, Card, Field, Input, PrimaryButton, Table, SortableHeader, useTableSort, DangerButton } from "@/components/admin/AdminUI";

export default function AdminClothingTypesList() {
  const qc = useQueryClient();
  const [form, setForm] = useState({ name: "", description: "" });
  const { data: types = [] } = useQuery({ queryKey: ["admin-types"], queryFn: async () => (await api.get("/admin/clothing-types")).data });
  const { sort, toggleSort, sortRows } = useTableSort();
  const sortedTypes = sortRows(types, (t, key) => t[key] ?? null);

  async function add() {
    if (!form.name) return;
    try {
      await api.post("/admin/clothing-types", form);
      setForm({ name: "", description: "" });
      qc.invalidateQueries({ queryKey: ["admin-types"] });
      toast.success("Type added");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  }

  async function remove(id) {
    if (!window.confirm("Delete this type?")) return;
    await api.delete(`/admin/clothing-types/${id}`);
    qc.invalidateQueries({ queryKey: ["admin-types"] });
  }

  async function update(id, field, value) {
    await api.patch(`/admin/clothing-types/${id}`, { [field]: value });
    qc.invalidateQueries({ queryKey: ["admin-types"] });
  }

  return (
    <div>
      <PageHeader title="Clothing types" subtitle="Taxonomy used to categorize items (Dresses, Tops, etc.)" />
      <Card className="mb-6">
        <div className="grid sm:grid-cols-3 gap-3 items-end">
          <Field label="Name"><Input value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} /></Field>
          <Field label="Description"><Input value={form.description} onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} /></Field>
          <PrimaryButton onClick={add}>Add type</PrimaryButton>
        </div>
      </Card>
      <div className="bg-white border border-[#E9ECEF] rounded-lg overflow-hidden">
        <Table>
          <thead className="bg-[#F8F9FA] border-b border-[#E9ECEF] text-xs uppercase tracking-wider text-[#6C757D]">
            <tr>
              <SortableHeader label="Name" sortKey="name" sort={sort} onSort={toggleSort} />
              <SortableHeader label="Slug" sortKey="slug" sort={sort} onSort={toggleSort} />
              <SortableHeader label="Description" sortKey="description" sort={sort} onSort={toggleSort} />
              <SortableHeader label="" />
            </tr>
          </thead>
          <tbody>
            {sortedTypes.map((t) => (
              <tr key={t.id} className="border-b border-[#E9ECEF]">
                <td className="px-3 py-3"><Input defaultValue={t.name} onBlur={(e) => e.target.value !== t.name && update(t.id, "name", e.target.value)} /></td>
                <td className="px-3 py-3 font-mono text-xs text-[#6C757D]">{t.slug}</td>
                <td className="px-3 py-3 text-xs">{t.description}</td>
                <td className="px-3 py-3"><DangerButton onClick={() => remove(t.id)}>Delete</DangerButton></td>
              </tr>
            ))}
            {sortedTypes.length === 0 && <tr><td colSpan={4} className="px-3 py-12 text-center text-[#6C757D]">No types yet.</td></tr>}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
